import axios from '../marketplace/axios-marketplace';

const getAvaliacao = id => axios.get(`/avaliacoes-compras/${id}`);
const createAvaliacao = (id, data) => axios.put(`/avaliacoes-compras/${id}`, data);

export default {
  getAvaliacao,
  createAvaliacao,
};
